import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { StationService } from 'src/app/services/station.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { ArService } from 'src/app/services/ar.service';

@Component({
  selector: 'app-tax',
  templateUrl: './tax.component.html',
  styleUrls: ['./tax.component.scss']
})
export class TaxComponent implements OnInit {

  allTaxServices;
  stationsList;
  activePage
  searchText;


  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private reservationService: ReservationService,
    private stationService: StationService,
    private arservice: ArService) {
    this.getData();
  }

  getData() {
    this.searchText = ''
    this.getTaxServices();
  }

  ngOnInit() { 
    this.getTaxServices();
  }

  addTaxService() {
    this.router.navigateByUrl("home/add-tax-service");
  }
  editTaxService(taxService) {
    this.router.navigate(["home/edit-tax-service", taxService.TAX_ID])
   // this.router.navigate(["home/edit-tax-service",taxService.TAXBYSTATIONID,taxService.TAXSERVICESID])
  }
  
  getTaxServices() {
    this.spinner.show();
    this.arservice.getAllTaxPrices().subscribe(res => {
      this.allTaxServices = res['result'].sort((a,b) => a.STATION.localeCompare(b.STATION))
      //console.log(this.allTaxServices)
      this.spinner.hide();
    });
  }

  getTaxServicesByStationIds() {
    // this.employeeService.getEmployeesByStationId(this.stationsList).subscribe(data => {
    //   this.spinner.hide();
    //   if (data['result'] != null) {
    //     this.allEmployees = data['result'] as [];
    //     this.allEmployees = this.allEmployees.reverse();
    //   }
    // });
  }

  

  getAllStations() {
    this.stationService.getStations().subscribe(stations => {
      this.stationsList = stations['result'];
    })
  }

}
